<form>
<mat-card>
    <mat-card-title>
        <span [translate]="'admin.parametres.personnalisation.logos.title'"></span>
    </mat-card-title>
    <mat-card-content>
        <!-- Liste déroulante pour le logo principal -->
        <div class="row mb-1">
            <custom-input
                    ngDefaultControl
                    name="logoPrincipal"
                    customType="select"
                    [(ngModel)]="logoPrincipal"
                    [selectOptions]="optionsLogoPrincipal"
                    libelle="admin.parametres.personnalisation.logos.form.principal"
                    optionValue="value"
                    (onChange)="modifierPrincipaleOption()"
                    optionDisplay="libelle"
                    [disabled]="!hasMarqueBlanche">
            </custom-input>
            <mat-icon class="material-icons mb-md-2 ms-2 info-icon" *ngIf="!hasMarqueBlanche" [matTooltip]="'admin.parametres.personnalisation.logos.form.tooltipLicence' | translate">
                info_outline
            </mat-icon>
            <div class="col-md-4 col-md-offset-1 fond-logo" *ngIf="hasLogoPersonnalise && logoPrincipalPersonnaliseURL">
                <img class="preview-logo" [src]="logoPrincipalPersonnaliseURL">
            </div>
            <div class="col-md-4 col-md-offset-1 fond-logo" *ngIf="!hasLogoPersonnalise">
                <img src="../img/logo.svg" style="max-width: 400px; max-height: 200px;">
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12">
                <document-uploader *ngIf="hasLogoPersonnalise"
                                   [fileUploaderCustom]="fileUploaderPrincipalConfig"
                                   [title]="'admin.parametres.personnalisation.logos.form.deposezLogo'"
                                   (onDocumentsAdded)="onDocumentsPrincipalAdded($event)"
                                   [settings]="settings">
                </document-uploader>
            </div>
        </div>
        <!-- Liste déroulante pour le logo secondaire -->
        <div class="row mt-5 mb-1">
             <custom-input
                ngDefaultControl
                name="logoSecondaire"
                customType="select"
                [(ngModel)]="logoSecondaire"
                [selectOptions]="optionsLogoSecondaire"
                optionValue="value"
                libelle="admin.parametres.personnalisation.logos.form.Secondaire"
                (onChange)="modifierSecondaireOption()"
                optionDisplay="libelle">
            </custom-input>
            <div class="col-md-4 col-md-offset-1 fond-logo" *ngIf="hasLogoSecondaire && logoSecondairePersonnaliseURL">
                <img class="preview-logo" [src]="logoSecondairePersonnaliseURL">
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12">
                <document-uploader *ngIf="hasLogoSecondaire"
                                   [fileUploaderCustom]="fileUploaderSecondaireConfig"
                                   [title]="'admin.parametres.personnalisation.logos.form.deposezLogo'"
                                   (onDocumentsAdded)="onDocumentsSecondaireAdded($event)"
                                   [settings]="settings">
                </document-uploader>
            </div>
        </div>
    </mat-card-content>
</mat-card>
</form>